import { render, staticRenderFns } from "./dispatchEdit.vue?vue&type=template&id=28114730"
import script from "./dispatchEdit.vue?vue&type=script&lang=js"
export * from "./dispatchEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports